module.exports = __webpack_public_path__ + "img/logo.bf04fb01.png";